export const MODE_EXPAND = 'expand';
export const MODE_COMPRESS = 'compress';
